module.exports = __webpack_public_path__ + "static/media/frames-walls-normal.e1419a30.png";